export const MULTISELECT_GROUP = 'multiselect-group';
